import BigNumber from 'bignumber.js';
import type {
  ActivityModel,
  ActivityModelInternal,
  TradeModel,
  TradeModelInternal,
} from '@/types/model.types';

/** Wire format sends money as strings; widen on the way in. */

export function toActivityModel(internal: ActivityModelInternal): ActivityModel {
  return {
    ...internal,
    aggregateAmount: new BigNumber(internal.aggregateAmount),
    largestTradeAmount: new BigNumber(internal.largestTradeAmount),
  };
}

export function toTradeModel(internal: TradeModelInternal): TradeModel {
  return {
    ...internal,
    amount: new BigNumber(internal.amount),
    shareQuantity: internal.shareQuantity ? new BigNumber(internal.shareQuantity) : undefined,
  };
}
